const BASE_URL = process.env.REACT_APP_API_ENDPOINT
const BASE_PATH = '/api/v1/notifications/'

export default {
  getNotifTrace: `${BASE_URL}${BASE_PATH}trace/`
}
